import React, {Component} from 'react';
import {connect} from 'react-redux';
import fscreen from 'fscreen';
import {Actions} from '../../../common/actions';
import {Icon, Grid, Button} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import TimerCurrentDate from '../../../common/components/timerCurrentDate';
import RenderTable from './table';
import PieChart from './chart/pie';
import {filter, countBy} from 'lodash';
import './detail.scss';

let timer = null;
const importationsRefreshTime = 5 * 60 * 1000;

class LiquidationsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isFullScreen': false,
      'type': 'models',
      'modelSelected': '',
      'reservationSelected': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.LiquidationsList, scopes.See)) {
      this.props.push(paths.AccessDenied);
      return;
    }
    this.changeFullScreen();
    this.startTimer();
  }

  changeFullScreen() {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', this.handler.bind(this), false);
    }
  }

  handler() {
    if (!fscreen.fullscreenElement) {
      this.setState({'isFullScreen': false});
    }
  }

  startTimer() {
    const {invoiceOrder} = this.props;
    this.props.fetchLiquidationsDetail(invoiceOrder);

    timer = setInterval(() => {
      this.props.fetchLiquidationsDetail(invoiceOrder);
    }, importationsRefreshTime);
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  goToHome() {
    this.props.push(paths.Home);
  }

  toggleFullScreen() {
    if (!fscreen.fullscreenElement) {
      fscreen.requestFullscreen(document.documentElement);
      this.setState({'isFullScreen': true});
    } else {
      fscreen.exitFullscreen();
      this.setState({'isFullScreen': false});
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  filteredList() {
    const {liquidationsDetail} = this.props;
    const {type, modelSelected, reservationSelected} = this.state;
    if (type === 'models') {
      return {
        'list': liquidationsDetail,
        'field': 'model',
      };
    }
    if (type === 'reservations') {
      return {
        'list': filter(liquidationsDetail, {'model': modelSelected}),
        'field': 'reservedTo',
      };
    }
    if (type === 'colors') {
      return {
        'list': filter(liquidationsDetail, {'model': modelSelected, 'reservedTo': reservationSelected}),
        'field': 'externalColor',
      };
    }
  }

  getGroupedData() {
    const filteredList = this.filteredList();

    const groupedData = countBy(filteredList.list, filteredList.field);

    return Object.keys(groupedData).map((key) => {
      const detail = filteredList.list.filter((element) => {
        return element[filteredList.field] === key;
      });
      return {'name': key, 'total': groupedData[key], detail};
    });
  }

  render() {
    const {isFullScreen} = this.state;
    const {invoiceOrder} = this.props;
    const icon = isFullScreen ? 'compress' : 'expand';

    return (
      <div className='liquidations-detail-page'>
        <div className='title-bar'>
          <div className='title'>
            <Icon link name={'home'} color='red' size='big'
              onClick={this.goToHome.bind(this)} />
            <Icon name='arrow left' onClick={this.onCancelClick.bind(this)}/>
            <Icon link name={icon} size='big'
              onClick={this.toggleFullScreen.bind(this)} />
            <h2>Resumen de Liquidaciones</h2>
            <div className='title-bar-actions'>
              <TimerCurrentDate />
            </div>
          </div>
        </div>

        <div className='title-bar'>
          <div className='title'>
            <h2>Pedido factura: {invoiceOrder}</h2>
          </div>
        </div>

        {this.renderData()}
      </div>
    );
  }

  renderData() {
    const {type} = this.state;
    const getData = this.getGroupedData();
    if (!getData.length) {
      return (
        <div className='without-data'>No hay datos</div>
      );
    }

    return (
      <div>
        <div className='title-bar data-selected-section'>
          <div className='title'>
            <h4>Filtros Seleccionados: </h4>
            {this.renderModelSelected()}
            {this.renderReservatioSelected()}
          </div>
        </div>

        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column width={10}>
              <PieChart type={type} data={getData}
                onClickChangeType={this.onChangeType.bind(this)}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <RenderTable data={getData} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  renderModelSelected() {
    const {modelSelected} = this.state;
    if (!modelSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.clearDataSelected.bind(this, 'models')}
      >
        {modelSelected}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderReservatioSelected() {
    const {reservationSelected} = this.state;
    if (!reservationSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.clearDataSelected.bind(this, 'reservations')}
      >
        {reservationSelected}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  clearDataSelected(type) {
    const newState = {type};
    if (type === 'models') {
      newState.modelSelected = '';
      newState.reservationSelected = '';
    }
    if (type === 'reservations') {
      newState.reservationSelected = '';
    }
    this.setState(newState);
  }

  onChangeType(type, name) {
    const newState = {};
    if (type === 'models') {
      newState.type = 'reservations';
      newState.modelSelected = name;
    }
    if (type === 'reservations') {
      newState.type = 'colors';
      newState.reservationSelected = name;
    }
    this.setState(newState);
  }
}

const mapStateToProps = (state, ownProps) => {
  const {invoiceOrder} = ownProps.params;
  return {
    invoiceOrder,
    'loading': state.liquidationsList.loadingDetail,
    'liquidationsDetail': state.liquidationsList.listDetail,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {
  fetchLiquidationsDetail,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchLiquidationsDetail,
})(LiquidationsDetail));
